import { render, staticRenderFns } from "./StampUsageRecord.vue?vue&type=template&id=07fe6034&scoped=true&"
import script from "./StampUsageRecord.vue?vue&type=script&lang=js&"
export * from "./StampUsageRecord.vue?vue&type=script&lang=js&"
import style0 from "./StampUsageRecord.vue?vue&type=style&index=0&id=07fe6034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe6034",
  null
  
)

export default component.exports